module.exports = __webpack_public_path__ + "static/media/autoCADAddons1.062a77fa.png";